import { Component, OnInit, ViewChild } from '@angular/core';
import { Authenticationservice } from '../../services/authentication.service';
import axios from 'axios';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { CustomService } from '../../services/custom.service';

@Component({
  selector: 'app-docforaskformoney67',
  templateUrl: './docforaskformoney67.component.html',
  styleUrls: ['./docforaskformoney67.component.css']
})
export class Docforaskformoney67Component implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private route: ActivatedRoute
  ) {
    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
    this.time = result;

    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.supname = userdata.supname;

  }
  tab_s = 1;
  time;
  zone;
  supname: string;
  supcode: string;
  allpromisebyzone;
  displayaskformoney = ['number', 'datetime', 'plat_no', 'farmername', 'mngcomment', 'financialamount', 'docdesc', 'print', 'cancle'];

  year = '';
  ngOnInit(): void {
    this.year = this.route.snapshot.paramMap.get('year');
    console.log('year: ', this.year);

    this.Loadallpromisebyzone();
  }


  print_p() {
    setTimeout(() => {
      window.print();
    }, 100);
  }


  Filterby(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allpromisebyzone.filter = filterValue.trim().toLowerCase();;
    if (this.allpromisebyzone.paginator) {
      this.allpromisebyzone.paginator.firstPage();
    }
  }

  txt_fm = { fmcf: '', fmct: '' };
  databyfm = [];
  Loaddatabyfmcode() {
    let did = this.txt_fm;
    this.txt_fm.fmct = did.fmcf
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance" + this.year + "]&w=[fmcode]='" + did.fmcf + "'";
    axios.get(url)
      .then(res => {
        this.spinner.hide();
        let data = res.data;
        if (data.length) {
          data.sort(function (a, b) { return b.docid - a.docid });
          this.databyfm = data;
        }
        else this.databyfm = [];
      }).catch(err => { throw (err); })
  }

  cnt_over = 0;
  alldatainzone;
  Loadallpromisebyzone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance" + this.year + "]&w=zonePost=%27" + this.zone + "%27and[doc_status]in('0','2')";
    axios.get(url)
      .then(res => {
        let data = res.data;
        if (data.length) {
          data.sort(function (a, b) { return b.docid - a.docid });
          this.alldatainzone = data;
          this.allpromisebyzone = new MatTableDataSource(data);
          this.paginator.length = data.length;
          this.paginator.pageSize = 10;
          this.allpromisebyzone.sort = this.sort;
          this.allpromisebyzone.paginator = this.paginator;
        }
        else this.alldatainzone = [];
        console.log('cnt_over:', this.cnt_over);
      }).catch(err => { throw (err); })
  }

  remove_val(docid = '') {
    this.dataone = this.dataone.filter(el => el.docid != docid);
    this.summoney = ((this.dataone.map(el => { return el.money_amt })).reduce((a, b) => a + b, 0));
  }

  dataone = [];
  datafamer = [];
  summoney = 0;
  retadata = [];
  async print_doc(fmcode: string, d = 0) {
    //console.log(fmcode)
    this.cnt_over = 0;
    if (d == 0) { this.dataone = this.alldatainzone.filter(el => el.FMCODE_B1 == fmcode); }
    else if (d == 1) { this.dataone = this.databyfm.filter(el => el.FMCODE_B1 == fmcode); }

    let cnt_o = this.dataone.filter(el => el.over_limit == 1);
    this.cnt_over = cnt_o.length;

    this.summoney = ((this.dataone.map(el => { return el.money_amt })).reduce((a, b) => a + b, 0));
    console.log(fmcode, cnt_o, ', cnt_over:', this.cnt_over);
    //console.log('dataone', this.dataone)
    this.datafamer = [];
    this.spinner.show();
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_farmer_basic]&w=[fmcode_b1]='" + fmcode + "'";
    await axios.get(url2)
      .then(res => {
        this.spinner.hide();
        let data = res.data
        if (data.length > 0) {
          this.datafamer = data;
          this.print_p();
        }
      }).catch(err => { throw (err); })

    this.retadata = [];
    /*let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_bt" + this.year + "farmer]&w=fmcode_b1=%27" + fmcode + "%27";
    await axios.get(url)
      .then(res => {
        this.spinner.hide();
        if (res.data.length > 0) {
          this.retadata = res.data;
          this.print_p();
        }
      }).catch(err => {
        throw (err);
      }
      )*/
  }


  DatetoLocal(thisdate: any) {
    const date1 = new Date(thisdate);
    let options: any = {
      // weekday: "short",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  // ยกเลิกคำขอ
  cancledoc_id(doc_id) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid=" + doc_id + "&doc_status=X";
    if (confirm("ต้องการยกเลิกรายการ ?") == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) { alert("ยกเลิกรายการแล้วค่ะ"); this.Loadallpromisebyzone(); }
          else {
            alert("!!! ไม่สำเร็จ !!!")
          }
        }).catch(err => { throw (err); })
    } else {
      return false;
    }
  }
}
